<div class="shared-ui-textarea shared-ui-control" *ngIf="control">
  <label for="txtArea" class="fwform-label">{{ label }}</label>
  <textarea name="textArea" [formControl]="control" rows="5" cols="50"></textarea>
  <ngb-alert *ngIf="control.errors" [dismissible]="false">
    <div class="shared-ui-textarea-val-error" *ngFor="let error of control.errors | validationErrorKeys">{{messages[error]}}</div>
  </ngb-alert>
</div>
